export const routePaths = {
  SignIn: '/',
  SignUp: '/signup',
  Dashboard: '/dashboard',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  TwoFactorAuthentication: '/two-factor-authentication',
  Subscription: '/subscription',
  SelectedSubscription: '/selected-subscription',
  PaymentSuccess: '/payment-success',
  MyProfile: '/my-profile',
  EditProfile: '/my-profile/edit',
  Camera: '/my-profile/camera',
  SecurityPrivacy: '/settings/security-privacy',
  Payments: '/payments',
  Notification: '/settings/notification',
  Help: '/settings/help',
  ManageSubscriptions: '/settings/subscriptions/manage',
  SettingSubscription: '/settings/subscriptions',
  ContributorStorage: '/settings/subscriptions/manage/photos',
  Photos: '/photos',
  TakeAPhoto: '/photos/camera',
  PaymentsSettings: '/settings/payments',
  Storage: '/settings/storage',
  Folders: '/photo/folders'
};
